import DateTimeHelper from 'helpers/date'
import FormatHelper from 'helpers/formats'
import { mapMutations } from 'vuex'

var ProgressBarMixin = {
  name: 'ProgressBar',
  data: function () {
    return {
      progress: 0
    }
  },
  computed: {
    eventDuration: function () {
      return DateTimeHelper.getDuration(this.startTime, this.endTime, 's')
    },
    progressPercent: function () {
      return this.progressUi * 100 + '%'
    },
    progressUi: function () {
      return Math.min(1, Math.max(0, this.progress))
    }
  },
  props: {
    startTime: {
      type: Number
    },
    endTime: {
      type: Number
    },
    rewind: Function
  },
  methods: {
    ...mapMutations([
      'UPDATE_NOW_TIME'
    ]),
    setProgressPoint: function (eventPast, property = 'progress') {
      let progress = FormatHelper.formatDecimal(eventPast / this.eventDuration, 4)
      this[property] = Math.min(1, Math.max(0, progress))
    },
    getProgressPoint: function (time = DateTimeHelper.nowString()) {
      if (time === null) {
        time = DateTimeHelper.nowString()
      }
      return FormatHelper.formatDecimal(DateTimeHelper.getDuration(this.startTime, time, 's') / this.eventDuration, 4)
    },
    setCheckInterval: function () {
      let minimalProgress = 0.01 // Minimal progress is 1%
      let interval = this.eventDuration * minimalProgress * 1000
      this.progress = this.getProgressPoint()
      if (this.interval) {
        clearInterval(this.interval)
      }
      if (this.progress >= 0 && this.progress < 1) {
        this.interval = setInterval(this.intervalFunction, interval)
      }
    },
    intervalFunction: function () {
      // console.log('Interval ProgressBarMixin')
      this.progress = this.getProgressPoint()
      this.UPDATE_NOW_TIME()
      if (this.progress >= 1) {
        this.$nextTick(() => {
          this.reloadMarker()
        })
      }
      if (this.progress === 1 || this.progress === 0) {
        clearInterval(this.interval)
      }
    }
  //   /**
  //    * Return event past in seconds
  //    * @return {Integer} in seconds
  //    */
  //   eventPast: function () {
  //     return DateTimeHelper.getDuration(this.startTime, DateTimeHelper.nowString(), 's')
  //   },
  //   goToTimeLive: function () {
  //     let setValue

  //     if (!this.changeProgress.toEnd) {
  //       let durationInSeconds = this.eventDurationMs / 1000
  //       let progressUnit = 1 / durationInSeconds
  //       let newValue = this.userProgress + progressUnit * this.changeProgress.time

  //       if (newValue < this.progress - this.protectedPercent && newValue > 0 && this.type === 'live') {
  //         this.calculatingUserProgress = true
  //         console.log('time first', newValue, this.userProgress, this.progress)
  //         this.$_eonProgressSlider.noUiSlider.set(newValue)
  //         setValue = newValue * 100
  //       } else if (newValue > this.progress - this.protectedPercent && this.type === 'live') {
  //         console.log('time second', 'progressUnit', progressUnit, 'newValue', newValue, 'userProgress', this.userProgress, 'progress', this.progress)
  //         if (this.changeProgress.direction === 'rewind') {
  //           this.calculatingUserProgress = true
  //           setValue = (this.progress - progressUnit * 30) * 100
  //         } else {
  //           this.forward()
  //         }
  //       } else if (newValue < 0 && this.type === 'live') {
  //         console.log('time third', newValue, this.userProgress, this.progress)
  //         this.rewind()
  //       }
  //     } else {
  //       console.log('end first', this.userProgress, this.progress)
  //       this.forward()
  //     }
  //     if (setValue) {
  //       this.calculatingUserProgress = false
  //       this.clearVideoInterval()
  //       this.$emit('sliderChanged', setValue) // TODO consider how to refactor this
  //       setTimeout(() => { // TODO bad solution. Find solution for eventElapsed
  //         this.setVideoInterval()
  //       }, 0)
  //     }
  //   }
  },
  watch: {
    endTime: function () {
      // When endTime changes we clear current interval, recalculate progress point and interval
      clearInterval(this.interval)
      this.setCheckInterval()
    },
    changeProgressFlag: function () {
      if (this.playerType === 'nowTv') {
        this.goToTimeLive()
      }
    }
  },
  destroyed: function () {
    clearInterval(this.interval)
  },
  created () {
    this.setCheckInterval()
  }
}

export default ProgressBarMixin



// WEBPACK FOOTER //
// ./src/containers/mixins/ProgressBarMixin.js